export default "__VITE_ASSET__DTz5WLpI__"